module.exports = __webpack_public_path__ + "img/personal-possessions.69ffc706.png";